export enum sponsorSlugs{
    UNIVERSAL='do-universal',
    SENASA='do-senasa',
    PRIMERA='do-primera',
    HUMANO='do-humano',
    KONEKSI='koneksi'
}

export enum localClaimTypes{
    MEDICAL_ENCOUNTER = 'medical-encounter',
    MEDICAL_PROCEDURE = 'medical-procedure',
    LABORATORY = 'laboratory',
}

export enum pageIds {
    MEDICAL_ENCOUNTER = 'medical-encounter',
    MEDICAL_PROCEDURE = 'medical-procedure',
    LABORATORY = 'laboratory',
    CONTINUE_PROCESS_CLAIM = 'continue-process-claim',
    CONSULT_CLAIM= 'consult-claim',
    NEW_CLAIM= 'new-claim'
}

export enum claimFileTypes {
    AMBULATORY_TEST_FORM = 'do-ambulatory-test-form',
    MEDICAL_PROCEDURE_PRESCRIPTION = 'do-medical-procedure-prescription',
    PRESCRIPTION = 'do-prescription',
    PRESCRIPTION_2 = 'do-prescription-2',
    PRESCRIPTION_3= 'do-prescription-3',
    DIAGNOSTIC_TEST_STUDY_RESULT= 'do-diagnostic-test-study-result',
    LABORATORY_RESULT= 'do-laboratory-results'
}

export enum claimStatus{
    COMPLETED='COMPLETADA',
    VOIDED='ANULADA',
    SETTLED='RADICADA'
}